import { requiredUuidString } from '../zod-helpers/index.js';
import { withCalEventTemplateBody } from './with-cal-event-template-body.js';
export const createCalEventTemplateInputSchema = withCalEventTemplateBody({
    brandId: requiredUuidString('Brand is required.', 'Invalid brand ID.'),
});
//# sourceMappingURL=create-cal-event-template-input.js.map